import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API } from '@constants/api';
import { API_BASE_URL } from '@constants/injection_tokens';
import { flattenObj } from '@utils/utils';
import { map } from 'rxjs';
import { NomenclatureFilters } from '../models/nomenclature';

@Injectable({ providedIn: 'root' })
export class NomenclatureService {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {}

  search<T = any[]>(filters: NomenclatureFilters) {
    const url = `${this.baseUrl}${API.SEARCH.Get}`;
    const params = flattenObj(filters);

    return this.http.get<T>(url, {
      params: new HttpParams({ fromObject: params }),
    });
  }

  getDocumentTypes(filters: any) {
    const url = `${this.baseUrl}${API.NOMENCLATURES.DOCUMENTS_PER_REQUEST}`;
    const params = flattenObj(filters);

    return this.http.get(url, {
      params: new HttpParams({ fromObject: params }),
    })
      .pipe(map((data: any) => data));;
  }
}
